import axios from 'axios';
import { getEnvironment } from '@global/helpers';
const Config = getEnvironment();

const baseUrl = Config.MS_B2B_CATALOG_API_URL;

export const getBrands = (params = {}) => {
  return axios.get(`${baseUrl}/brands`, params);
};

export const getBrandCount = (params = {}) => {
  return axios.get(`${baseUrl}/brands/count`, params);
};

export const getBrandDetail = (id, params = {}) => {
  return axios.get(`${baseUrl}/brands/${id}`, params);
};

export const updateBrand = (id, params = {}) => {
  return axios.put(`${baseUrl}/brands/${id}`, params);
};

const getBrandsLetter = (params = {}) => {
  return axios.get(`${baseUrl}/brands/letters`, params);
};

const getCategories = (params = {}) => {
  return axios.get(`${baseUrl}/categories`, params);
};

const getCategoriesCount = (params = {}) => {
  return axios.get(`${baseUrl}/categories/count`, params);
};

export const getProducts = (params = {}) => {
  return axios.get(`${baseUrl}/products`, params);
};

export const getProductCount = (params = {}) => {
  return axios.get(`${baseUrl}/products/count`, params);
};

export const getProductDetail = (id) => {
  return axios.get(`${baseUrl}/products/${id}`);
};

export const exportProducts = (params = {}) => {
  return axios.post(`${baseUrl}/products/pdf`, params);
};

export const getNewArrivalBestSeller = (params = {}) => {
  return axios.get(`${baseUrl}/new-arrival-best-seller`, params);
};

export const getNewArrivalBestSellerCount = (params = {}) => {
  return axios.get(`${baseUrl}/new-arrival-best-seller/count`, params);
};

export const createNewArrivalBestSeller = (params = {}) => {
  return axios.post(`${baseUrl}/new-arrival-best-seller`, params);
};

export const updateNewArrivalBestSeller = (id, params = {}) => {
  return axios.put(`${baseUrl}/new-arrival-best-seller/${id}`, params);
};

export const getNewArrivalBestSellerDetail = (id, params = {}) => {
  return axios.get(`${baseUrl}/new-arrival-best-seller/${id}`, params);
};

export const getNewArrivalBestSellerProduct = (id, params = {}) => {
  return axios.get(`${baseUrl}/new-arrival-best-seller/${id}/products`, params);
};

export const getNewArrivalBestSellerProductCount = (id, params = {}) => {
  return axios.get(
    `${baseUrl}/new-arrival-best-seller/${id}/products/count`,
    params,
  );
};

export const createNewArrivalBestSellerProduct = (id, params = {}) => {
  return axios.post(
    `${baseUrl}/new-arrival-best-seller/${id}/products`,
    params,
  );
};

export const updateNewArrivalBestSellerProduct = (
  id,
  productId,
  params = {},
) => {
  return axios.put(
    `${baseUrl}/new-arrival-best-seller/${id}/products/${productId}`,
    params,
  );
};

export const deleteNewArrivalBestSellerProduct = (
  id,
  productId,
  combinationId,
  params = {},
) => {
  return axios.delete(
    `${baseUrl}/new-arrival-best-seller/${id}/products/${productId}/combinations/${combinationId}`,
    params,
  );
};

export const getPriceRules = (params = {}) => {
  return axios.get(`${baseUrl}/product-price-rules`, params);
};

export const getPriceRulesById = (id) => {
  return axios.get(`${baseUrl}/product-price-rules/${id}`);
};

export const getPriceRulesCount = (params = {}) => {
  return axios.get(`${baseUrl}/product-price-rules/count`, params);
};

export const createPriceRules = (payload = {}) => {
  return axios.post(`${baseUrl}/product-price-rules`, payload);
};

const getPriceRulesDetail = (id) => {
  return axios.get(`${baseUrl}/product-price-rules/${id}`);
};

export const uploadProductPriceRules = (payload = {}) => {
  return axios.post(`${baseUrl}/product-price-rules/bulk`, payload);
};

export const getPriceRulesProduct = (payload = {}, id) => {
  return axios.get(`${baseUrl}/product-price-rules/${id}/products`, payload);
};

export const getPriceRulesProductCount = (payload = {}, id) => {
  return axios.get(
    `${baseUrl}/product-price-rules/${id}/products/count`,
    payload,
  );
};

export const updatePriceRulesProductById = (id, payload = {}) => {
  return axios.put(`${baseUrl}/product-price-rules/${id}/products`, payload);
};

export const bulkAddProductPriceRules = (id, payload = {}) => {
  return axios.put(
    `${baseUrl}/product-price-rules/${id}/products/bulk`,
    payload,
  );
};

export const updatePriceRulesStatus = (id, status, payload = {}) => {
  return axios.put(
    `${baseUrl}/product-price-rules/${id}/status/${status}`,
    payload,
  );
};

export const deletePriceRule = (id) => {
  return axios.delete(`${baseUrl}/product-price-rules/${id}`);
};

export const getPriceRulesProductLog = (payload = {}) => {
  return axios.get(`${baseUrl}/logs`, payload);
};

export const getPriceRulesProductLogCount = (payload = {}) => {
  return axios.get(`${baseUrl}/logs/count`, payload);
};

export const actionMarketTypeProduct = (id, payload = {}) => {
  return axios.put(`${baseUrl}/products/${id}`, payload);
};

export const createMarketTypeProductBulk = (payload = {}) => {
  return axios.post(`${baseUrl}/products/market-type/bulk`, payload);
};

export const deletePriceRulesProducts = (
  id,
  product_id,
  combination_id,
  params = {},
) => {
  return axios.delete(
    `${baseUrl}/product-price-rules/${id}/products/${product_id}/combinations/${combination_id}`,
    params,
  );
};

export const updatePriceRulesProducts = (
  id,
  product_id,
  combination_id,
  payload = {},
) => {
  return axios.put(
    `${baseUrl}/product-price-rules/${id}/products/${product_id}/combinations/${combination_id}`,
    payload,
  );
};

export const getCMS = (params = {}) => {
  return axios.get(`${baseUrl}/cms`, params);
};

export const getCMSDetail = (id) => {
  return axios.get(`${baseUrl}/cms/${id}`);
};

export const getCMSCount = (params = {}) => {
  return axios.get(`${baseUrl}/cms/count`, params);
};

export const createCMS = (payload = {}) => {
  return axios.post(`${baseUrl}/cms`, payload);
};

export const deleteCMS = (id) => {
  return axios.delete(`${baseUrl}/cms/${id}`);
};

export const updateCMS = (id, payload = {}) => {
  return axios.put(`${baseUrl}/cms/${id}`, payload);
};

export const getCMSSectionDetail = (id, type) => {
  return axios.get(`${baseUrl}/cms/${id}/sections/${type}`);
};
export const getCMSSectionCount = (id, type, params = {}) => {
  return axios.get(`${baseUrl}/cms/${id}/sections/${type}/count`, params);
};

export const createCMSSection = (id, type, payload = {}) => {
  return axios.post(`${baseUrl}/cms/${id}/sections/${type}`, payload);
};

export const deleteCMSSection = (id, type, sectionId) => {
  return axios.delete(`${baseUrl}/cms/${id}/sections/${type}/${sectionId}`);
};

export const updateCMSSection = (id, type, sectionId, payload = {}) => {
  return axios.put(
    `${baseUrl}/cms/${id}/sections/${type}/${sectionId}`,
    payload,
  );
};

export const getGuideBooks = (params = {}) => {
  return axios.get(`${baseUrl}/guide-books`, params);
};

export const getGuideBooksCount = (params = {}) => {
  return axios.get(`${baseUrl}/guide-books/count`, params);
};

export const getGuideBookDetail = (id) => {
  return axios.get(`${baseUrl}/guide-books/${id}`);
};

export const getNewBestProducts = (type, payload = {}) => {
  return axios.get(`${baseUrl}/products/tabs/${type}`, payload);
};

export const getNewBestProductCount = (type, payload = {}) => {
  return axios.get(`${baseUrl}/products/tabs/${type}/count`, payload);
};

export const getProductPromotions = (id, combinationId, payload = {}) => {
  return axios.get(
    `${baseUrl}/products/${id}/promotions/${combinationId}`,
    payload,
  );
};

export const MsCatalog = {
  getPriceRulesById,
  getCategories,
  getProducts,
  getProductCount,
  getProductDetail,
  getNewArrivalBestSeller,
  getNewArrivalBestSellerCount,
  getNewArrivalBestSellerDetail,
  createNewArrivalBestSeller,
  updateNewArrivalBestSeller,
  getNewArrivalBestSellerProduct,
  getNewArrivalBestSellerProductCount,
  createNewArrivalBestSellerProduct,
  updateNewArrivalBestSellerProduct,
  deleteNewArrivalBestSellerProduct,
  getPriceRules,
  getPriceRulesCount,
  getPriceRulesDetail,
  getPriceRulesProduct,
  updatePriceRulesStatus,
  getBrands,
  getBrandCount,
  getBrandDetail,
  getBrandsLetter,
  actionMarketTypeProduct,
  createMarketTypeProductBulk,
  deletePriceRulesProducts,
  updatePriceRulesProducts,
  getCMS,
  getCMSDetail,
  getCMSCount,
  createCMS,
  updateCMS,
  deleteCMS,
  getCMSSectionDetail,
  getCMSSectionCount,
  createCMSSection,
  updateCMSSection,
  deleteCMSSection,
  getNewBestProducts,
  getNewBestProductCount,
  getProductPromotions,
  exportProducts,
  deletePriceRule,
  getCategoriesCount,
  getGuideBooks,
  getGuideBooksCount,
  getGuideBookDetail,
};
